/* eslint-disable max-lines-per-function */
// helpers
import { filterNotFillSection } from '../../utils/helperMethods';

// Components
import { FormElems, Alert, AlertModal } from '../../components/';

// Actions
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import {
    saveAndContinueRequest,
    resetSaveDataSuccessKey,
    submitFormRequest,
    submitFormError,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';
import {
    updateSectionDataRequest,
    addMerchantStepUpdateMakerRequest,
    resetUpdateDataSuccessKey,
    getMerchantSectionInfoRequest,
    updateSectionDataError,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';

// Constants
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';

// Libraries
import validate from './validator';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, FieldArray, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { last, isEmpty } from 'lodash';

// Component

// Validator

// Styles
import './notificationTab.scss';
import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';

const getRegisteredMail = values => {
    if (Array.isArray(values) && values[0] === '' && values[1]) {
        return [values[1]];
    } else if (Array.isArray(values) && values[0] === '') {
        return [];
    } else if (Array.isArray(values) && values[0]) {
        return [values[0]];
    }
    return !isEmpty(values) && [values];
};

const NotificationTab = ({
    merchantData,
    actions,
    auth,
    sectionType,
    nextPath,
    previousPath,
    history,
    handleSubmit,
    initialValues,
    isEditMode,
    isViewMode,
    editData,
    draftData,
    formData,
    onBoardSteps,
}) => {
    const {
        saveData,
        submitData,
        uniqueIdentifier: { uniqueId },
        timeline: { fields },
    } = merchantData;
    const data = draftData ? draftData.data : {};
    const { updateData } = editData;
    const { location } = history;
    const [isShowModal, setIsShowModal] = useState(false);
    const [isAdditionalEmailEnabled, setIsAdditionalEmailEnabled] = useState(
        false
    );

    const uniqueIdMail = data.registeredEmail || uniqueId;

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };
    useEffect(() => {
        resetErrors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            actions.getMerchantSectionInfoRequest(
                merchantId,
                fields,
                'notificationSection'
            );
        }
    }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    useEffect(() => {
        const finalEmailData = [];

        if ((isEditMode || isViewMode) && initialValues.multipleEmails) {
            initialValues.multipleEmails.forEach(emailData => {
                const config = [];
                if (emailData.isMSR) {
                    config.push('MSR');
                }
                if (emailData.isMTR) {
                    config.push('MTR');
                }
                finalEmailData.push({ emailId: emailData.emailId, config });
            });
            actions.change(
                'notification-form',
                'multipleEmails',
                finalEmailData
            );
            if (finalEmailData && finalEmailData.length > 0) {
                setIsAdditionalEmailEnabled(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValues?.multipleEmails, isEditMode, isViewMode]);

    useEffect(() => {
        const portalValue = formData.values.multipleEmails;
        const finalEmailData = [];

        if (portalValue && portalValue.length) {
            portalValue.forEach(emailData => {
                let isMSR = false;
                let isMTR = false;
                if (emailData) {
                    if (
                        Array.isArray(emailData.config) &&
                        emailData.config.includes('MSR')
                    ) {
                        isMSR = true;
                    }

                    if (
                        Array.isArray(emailData.config) &&
                        emailData.config.includes('MTR')
                    ) {
                        isMTR = true;
                    }
                    finalEmailData.push({
                        emailId: emailData.emailId,
                        isMSR,
                        isMTR,
                    });
                }
            });

            actions.change(
                'notification-form',
                'notificationEmailList',
                finalEmailData
            );
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.values.multipleEmails]);

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            const request = {
                uniqueIdentifier: uniqueId,
                userId: auth.userDetails.email,
            };
            const isAllFieldComplete = onBoardSteps
                .filter(item => item.sectionType !== sectionType)
                .every(item => item.status === 'Complete');

            if (!isAllFieldComplete) {
                setIsShowModal(true);
            } else {
                toast.info(SUCCESS_MESSAGES.CREATE_ENTITY('Merchant'));
                onNext();

                // actions.addBDOnboardingMakerRequest(makerRequest);
            }
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
                actions.submitFormError({ error: {} });
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(
                SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS('Notification')
            );
            onNext();
            actions.resetUpdateDataSuccessKey();
        }
        return () => {
            if (
                updateData.isSuccess &&
                updateData.sectionType === sectionType
            ) {
                actions.resetUpdateDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    const handleFormSubmit = values => {
        const multipleEmails =
            isAdditionalEmailEnabled && values?.notificationEmailList
                ? values?.notificationEmailList
                : [];
        const registeredEmail = getRegisteredMail(values.registeredEmail) || [];
        const request = {
            uniqueIdentifier: uniqueIdMail,
            sectionType,
            data: {
                emailList: [...values.emailList, ...registeredEmail],
                mobileList: values.mobileList,
                multipleEmails,
            },
        };
        if (isEditMode) {
            const merchantId = last(location.pathname.split('/'));
            let emailList = [];
            if (
                registeredEmail.length > 0 &&
                values.emailList.includes(uniqueIdMail)
            ) {
                emailList = [...values.emailList];
            } else {
                emailList = [...values.emailList, ...registeredEmail];
            }
            if (registeredEmail && registeredEmail.length === 0) {
                const indexOfUniqueId = emailList.indexOf(uniqueIdMail);
                if (indexOfUniqueId > -1) {
                    emailList.splice(indexOfUniqueId, 1);
                }
            }
            const updateRequest = {
                configurationType: 'NOTIFICATION',
                entityCode: merchantId || '',
                merchantConfig: {
                    notificationData: {
                        emailList,
                        mobileList: values.mobileList,
                        multipleEmails,
                    },
                },
            };
            const makerDetails = {
                makerId: auth.userDetails.email || '',
                idempotencyId: merchantId,
                eventType: MAKER_CHECKER_EVENT_TYPES.NOTIFICATION,
            };
            const isAllFieldComplete = onBoardSteps
                .filter(item => item.sectionType !== sectionType)
                .every(item => item.status === 'Complete');

            if (!isAllFieldComplete) {
                setIsShowModal(true);
            } else {
                actions.addMerchantStepUpdateMakerRequest(
                    updateRequest,
                    sectionType,
                    makerDetails
                );
            }
        } else if (isViewMode) {
            onNext();
        } else {
            const makerDetails = {
                makerId: auth.userDetails.email || '',
                idempotencyId: uniqueId,
                eventType: MAKER_CHECKER_EVENT_TYPES.ONBOARDING,
            };
            actions.saveAndContinueRequest(request, sectionType, makerDetails);
        }
    };

    const onCloseModal = () => {
        setIsShowModal(false);
    };

    const onNext = () => {
        history.push('/mob');
    };

    const onBack = () => {
        resetErrors();
        history.push(previousPath);
    };

    const resetFormErrors = () => {
        actions.updateSectionDataError({ error: {} });
    };

    const errorDetails = isEditMode ? updateData : saveData;
    const formError = formData.syncErrors && formData.syncErrors.commonErrors;

    const notFillSectionName = filterNotFillSection(onBoardSteps, sectionType);
    return (
        <form
            className="notification-list-form"
            onSubmit={handleSubmit(handleFormSubmit)}
            onChange={resetFormErrors}
        >
            <div className="notification-tab card">
                <h2 className="tab-title">Notification</h2>
                <AlertModal
                    modalIsOpen={isShowModal}
                    closeModal={onCloseModal}
                    primaryButtonText="OK"
                    showActions={true}
                    onSuccessModal={onCloseModal}
                    message={`Please update ${notFillSectionName} sections.`}
                />

                {errorDetails.error && errorDetails.error.errorMessage ? (
                    <Alert customClass="error-msg">
                        {errorDetails.error.errorMessage}
                    </Alert>
                ) : null}
                {formError ? (
                    <Alert customClass="error-msg">{formError}</Alert>
                ) : null}
                <div className="notification-section">
                    <FieldArray
                        name="emailList"
                        props={{
                            auth,
                            isViewMode,
                            emailList: data.emailList ? data.emailList : [],
                            uniqueId: uniqueIdMail,
                        }}
                        component={renderEmails}
                    />
                    <FieldArray
                        name="mobileList"
                        props={{ isViewMode }}
                        component={renderMobiles}
                    />
                </div>
            </div>

            <div className="notification-tab card multiple-emails-wrapper">
                <h2 className="tab-title">
                    Multiple Email Notification
                    <span className="form-field form-field-switch">
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={isAdditionalEmailEnabled}
                                onChange={() => {
                                    setIsAdditionalEmailEnabled(
                                        !isAdditionalEmailEnabled
                                    );
                                }}
                                disabled={isViewMode}
                            />
                            <span className="slider round" />
                        </label>
                    </span>
                </h2>
                {isAdditionalEmailEnabled ? (
                    <div className="multiple-emails">
                        <FieldArray
                            name="multipleEmails"
                            props={{
                                auth,
                                isViewMode,
                            }}
                            component={renderMultipleEmails}
                        />
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {!isViewMode &&(
                <>
            <div className="form-section action">
                <FormElems.Button
                    buttonType="secondary"
                    text="BACK"
                    type="button"
                    id="back-btn"
                    handleClick={onBack}
                    customClass="back-btn"
                />
                <FormElems.Button
                    buttonType="primary"
                    id="submit-btn"
                    text="SUBMIT"
                    isDisable={formError}
                />
            </div>
            </>
            )}
        </form>
    );
};

const renderEmails = ({
    fields,
    meta: { error, submitFailed },
    uniqueId,
    isViewMode,
    emailList,
}) => {
    const emailChecks = [
        {
            label: '',
            value: uniqueId,
            checked: emailList.includes(uniqueId),
        },
    ];
    const formFields = fields.getAll();
    return (
        <div className="col-section padLeft0">
            <div className="section-title">
                <span>Email Notification</span>
                {!isViewMode && (
                    <FormElems.Button
                        type="button"
                        buttonType="secondary"
                        id="add-email"
                        text={`+ Add Email`}
                        customClass="btn-small"
                        handleClick={() => {
                            if (
                                formFields.filter(field => field !== uniqueId)
                                    .length < 3
                            ) {
                                fields.push();
                            }
                        }}
                        title="You can only add a maximum of 3 emails"
                    />
                )}
            </div>
            <div className="register-section">
                <p>Registered Email ID</p>
                <div className="form-section side-by">
                    <p className="label">{uniqueId}</p>
                    <div className="form-field">
                        <Field
                            name="registeredEmail"
                            id="registered-email"
                            options={emailChecks}
                            valueField="value"
                            labelField="label"
                            noLabel
                            component={FormElems.Checkbox}
                            isDisabled={isViewMode}
                        />
                    </div>
                </div>
                {fields.map((email, index) => (
                    <>
                        {formFields[index] !== uniqueId && (
                            <div className="form-section">
                                <div className="form-field">
                                    <p className="label">
                                        Other Email ID
                                        {/* {formFields.includes(uniqueId)
                                            ? formFields[index] !== undefined
                                                ? otherEmails.indexOf(
                                                      formFields[index]
                                                  ) + 1
                                                : index + 1
                                            : index + 1}{' '} */}
                                        {/* {formFields[index] !== undefined
                                            ? otherEmails.indexOf(
                                                  formFields[index]
                                              ) + 1
                                            : index + 1}{' '}
                                        {formFields[index] !== undefined
                                            ? 'some'
                                            : 'notsome'} */}
                                    </p>
                                    <Field
                                        name={email}
                                        id={`${email}-${index}`}
                                        type="text"
                                        component={FormElems.Input}
                                        placeholder="Enter Email"
                                        disabled={isViewMode}
                                    />
                                </div>
                                {!isViewMode && (
                                    <FormElems.Button
                                        id={`remove-${index}`}
                                        type="button"
                                        buttonType="secondary"
                                        text="x Remove"
                                        customClass="btn-small"
                                        handleClick={() => fields.remove(index)}
                                    />
                                )}
                            </div>
                        )}
                    </>
                ))}
            </div>
        </div>
    );
};

const renderMobiles = ({
    fields,
    meta: { error, submitFailed },
    auth,
    isViewMode,
}) => (
    <div className="col-section">
        <div className="section-title">
            <span>SMS Notification</span>
            {!isViewMode && (
                <FormElems.Button
                    type="button"
                    buttonType="secondary"
                    id="add-number"
                    text={`+ Add Number`}
                    customClass="btn-small"
                    handleClick={() => {
                        if (fields.length < 3) {
                            fields.push();
                        }
                    }}
                    title="You can only add a maximum of 3 numbers"
                />
            )}
        </div>
        <div className="register-section">
            {fields.map((mobile, index) => (
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Mobile Number</p>
                        <Field
                            name={mobile}
                            id={`mobileNumber-${index}`}
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Mobile Number"
                            disabled={isViewMode}
                        />
                    </div>
                    {!isViewMode && (
                        <FormElems.Button
                            type="button"
                            buttonType="secondary"
                            id={`removeNumber-${index}`}
                            text="x Remove"
                            customClass="btn-small"
                            handleClick={() => fields.remove(index)}
                        />
                    )}
                </div>
            ))}
        </div>
    </div>
);

const renderMultipleEmails = ({ fields, isViewMode }) => {
    const checkboxOptions = [
        {
            label: 'MSR',
            value: 'MSR',
            checked: false,
        },
        {
            label: 'MTR',
            value: 'MTR',
            checked: false,
        },
    ];

    if (fields.length <= 0) {
        fields.push({});
    }

    return (
        <>
            {fields && fields.length ? (
                <>
                    {fields.map((field, index) => {
                        return (
                            <div className="multiple-emails">
                                <div className="field-wrapper">
                                    <div className="multiple-email-input">
                                        <p>Alternate Email ID</p>
                                        <Field
                                            name={`${field}.emailId`}
                                            id={`${field}.emailId`}
                                            type="text"
                                            component={FormElems.Input}
                                            placeholder="Enter Email"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                    <div className="multiple-email-checkbox">
                                        <Field
                                            name={`${field}.config`}
                                            id={`${field}.config`}
                                            options={checkboxOptions}
                                            valueField="value"
                                            labelField="label"
                                            disabled={isViewMode}
                                            isDisabled={isViewMode}
                                            component={FormElems.Checkbox}
                                        />
                                    </div>

                                    <div className="multiple-email-actions">
                                        <p />
                                        {fields.length > 1 ? (
                                            <FormElems.Button
                                                type="button"
                                                buttonType="secondary"
                                                id="remove-email"
                                                text={'x Remove'}
                                                customClass="multiple-email-delete-btn"
                                                handleClick={() =>
                                                    fields.remove(index)
                                                }
                                                disabled={isViewMode}
                                            />
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </>
            ) : (
                <></>
            )}
            <div className="multiple-email-actions">
                {fields.length < 3 ? (
                    <FormElems.Button
                        type="button"
                        buttonType="secondary"
                        id="add-email"
                        text={`+ Add Email`}
                        customClass="multiple-email-add-btn"
                        handleClick={() => {
                            fields.push();
                        }}
                        disabled={isViewMode}
                    />
                ) : (
                    <></>
                )}
            </div>
        </>
    );
};

renderMultipleEmails.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    uniqueId: PropTypes.object,
    isViewMode: PropTypes.bool,
};

renderMobiles.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    uniqueId: PropTypes.object,
};

renderEmails.propTypes = {
    fields: PropTypes.object,
    meta: PropTypes.object,
    auth: PropTypes.object,
    uniqueId: PropTypes.object,
};

NotificationTab.propTypes = {
    data: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    merchantData: PropTypes.object,
    actions: PropTypes.object,
    auth: PropTypes.object,
    sectionType: PropTypes.string,
    initialValues: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    formData: PropTypes.object,
    draftData: PropTypes.object,
    onBoardSteps: PropTypes.object,
};

const mapStateToProps = ({ auth, form, merchantData, editData }) => ({
    auth,
    formData: form['notification-form'],
    merchantData,
    editData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            saveAndContinueRequest,
            resetSaveDataSuccessKey,
            updateSectionDataRequest,
            addMerchantStepUpdateMakerRequest,
            resetUpdateDataSuccessKey,
            submitFormRequest,
            submitFormError,
            getMerchantSectionInfoRequest,
            updateSectionDataError,
            change,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'notification-form',
            enableReinitialize: true,
            validate,
        }),

        connect(mapStateToProps, mapDispatchToProps)
    )(NotificationTab)
);
